const servicesPageDataArabic = {
    page_heading: "الخدمات",
    breadcrumb: [
        { name: "إتصل بنا", className: "breadcrumb-item", link: "/" },
        { name: "الصفحة", className: "breadcrumb-item", link: "#" },
        { name: "الخدمات", className: "breadcrumb-item active" }
    ],
    features_list: [
        {
            id: 1,
            icon: 'uil uil-fire h2 text-primary',
            title: 'حلول التكييف الفعالة',
            description:
                'اكتشف تصميمات التكييف المبتكرة التي تضمن الراحة الأمثل في أي بيئة.',
        },
        {
            id: 2,
            icon: 'uil uil-wind h2 text-primary',
            title: 'إدارة التهوية',
            description:
                'استراتيجيات تهوية فعالة للحفاظ على جودة الهواء النقي والنظيف في جميع أنحاء مساحتك.',
        },
        {
            id: 3,
            icon: 'uil uil-search h2 text-primary',
            title: 'التخطيط الاستراتيجي لأنظمة التدفئة والتهوية وتكييف الهواء',
            description:
                'وضع إستراتيجيات والبحث عن أفضل حلول التدفئة والتهوية وتكييف الهواء  المصممة خصيصًا لتلبية احتياجاتك ومتطلباتك الخاصة.',
        },
        {
            id: 4,
            icon: 'uil uil-cloud-sun h2 text-primary',
            title: 'التحكم في المناخ',
            description:
                'انغمس في الراحة مع حلولنا المتقدمة للتحكم في المناخ .. استمتع بأداء تبريد لا مثيل له مصمم للتكيف بسلاسة مع مختلف الظروف الجوية، مما يضمن الراحة المثالية على مدار العام.',
        },
        {
            id: 5,
            icon: 'uil uil-calendar-alt h2 text-primary',
            title: 'تقارير الأداء اليومية',
            description:
                'احصل على تقارير شاملة عن الأداء اليومي لأنظمة التدفئة والتهوية وتكييف الهواء لديك لاتخاذ قرارات مستنيرة.',
        },
        {
            id: 6,
            icon: 'uil uil-globe h2 text-primary',
            title: 'دعم المنطقة الزمنية العالمية',
            description:
                'يمكنك الوصول إلى مراقبة نظام التدفئة والتهوية وتكييف الهواء (HVAC) والتحكم فيه في الوقت الفعلي، مما يضمن الراحة عبر المناطق الزمنية المختلفة.',
        },
        {
            id: 7,
            icon: 'uil uil-wrench h2 text-primary',
            title: 'صيانة المعدات',
            description:
                'تأكد من طول العمر والأداء الأمثل لمعدات التدفئة والتهوية وتكييف الهواء (HVAC) الخاصة بك من خلال خدمات الصيانة المنتظمة والاستباقية التي نقدمها.',
        },
        {
            id: 8,
            icon: 'uil uil-lightbulb h2 text-primary',
            title: 'حلول موفرة للطاقة',
            description:
                'قم بتنفيذ حلول وتكييف الهواء (HVAC) الموفرة للطاقة لتقليل البصمة الكربونية وخفض تكاليف المرافق دون المساس بالأداء.',
        },
        {
            id: 9,
            icon: 'uil uil-water h2 text-primary',
            title: 'مراقبة الرطوبة',
            description:
                'حافظ على مستويات رطوبة داخلية مثالية من خلال أنظمة التدفئة والتهوية وتكييف الهواء (HVAC) المتقدمة لدينا، مما يعزز الراحة ويمنع حدوث مشكلات مثل العفن والعفن الفطري.',
        },
        {
            id: 10,
            icon: 'uil uil-shield-check h2 text-primary',
            title: 'ضمان جودة الهواء',
            description:
                'تأكد من جودة الهواء الداخلي الممتازة من خلال أنظمة التدفئة والتهوية وتكييف الهواء (HVAC) لدينا، المجهزة بتقنيات الترشيح والتنقية المتقدمة.',
        },
        {
            id: 11,
            icon: 'uil uil-chart-line h2 text-primary',
            title: 'تحليلات الأداء',
            description:
                'يمكنك الوصول إلى التحليلات التفصيلية وبيانات الأداء الخاصة بأنظمة التدفئة والتهوية وتكييف الهواء (HVAC)، مما يسمح لك باتخاذ قرارات مبنية على البيانات لتحقيق الكفاءة المثلى.',
        },
        {
            id: 12,
            icon: 'uil uil-user-md h2 text-primary',
            title: 'الاستشارات المهنية',
            description:
                'مشرف التحرير',
        },
    ],
    our_work: {
        work_list: [
            {
                imgUrl: '1.jpg',
                title: 'تحويل الرؤية',
                subtitle: 'استوديو',
                author: 'كالفين كارلو',
                date: '13 أغسطس 2019',
            },
            {
                imgUrl: '2.jpg',
                title: 'مجلة الألوان',
                subtitle: 'تصميم الويب',
                author: 'كالفين كارلو',
                date: '13 أغسطس 2019',
            },
            {
                imgUrl: '3.jpg',
                title: 'مستحضرات التجميل للسبا',
                subtitle: 'تطوير',
                author: 'كالفين كارلو',
                date: '13 أغسطس 2019',
            },
            {
                imgUrl: '4.jpg',
                title: 'قهوة رايزر',
                subtitle: 'تمييز العلامة التجارية',
                author: 'كالفين كارلو',
                date: '13 أغسطس 2019',
            },
        ],
    },
    endSection: {
        title: "قم بترقية راحتك مع شركه سبل الاعمال للتكييف",
        description: [
            { type: "text", content: "اكتشف التميز في مجال التدفئة والتهوية وتكييف الهواء (HVAC) مع" },
            { type: "highlighted", content: "شركه سبل الاعمال" },
            { type: "text", content: "للتكييف (HVAC). ارفع مستوى الراحة والكفاءة وجودة الهواء في مساحتك." },
        ],
        buttonText: "ابقى على تواصل"
    },
    seeMore: "رؤية المزيد",
    hideMore: "إخفاء المزيد",
};

export { servicesPageDataArabic }
